module.exports = __webpack_public_path__ + "static/media/elena-cardoso.9eef36e0.jpg";